import React, { useState } from 'react';
import { Button, Grid, Typography, Container, Box, CircularProgress } from '@material-ui/core';
import Layout from '../Layout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CustomBreadcrumbs from '../Breadcrumb';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { assetDeclarationFileUpload } from '../../ReduxStore/AssetDisposalSlice';
import template1 from '../../Assets/template1.docx';
import template2 from '../../Assets/template2.docx';
import template3 from '../../Assets/template3.docx';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';



const UploadAssetDeclaration = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];

    const [postLoading, setPostLoading] = useState(false);
    const vendorCode = localStorage.getItem("vendorCode");
    const [selectedFile, setSelectedFile] = useState(null);
    const Role = localStorage.getItem("userRole");

    const handleFileUpload = (e) => {
        const allowedExtensions = ["doc", "docx","pdf"];

        const file = e.target.files[0];
        const fileName = file.name;
        // Validate for double extensions
        const fileParts = fileName.split('.');
        if (fileParts.length !== 2) {
            toast.info('Invalid file name. Ensure it has only one valid extension.');
            return;
        }

        // Check for invalid file names (e.g., hidden files starting with ".")
        if (file.name.startsWith(".")) {
            toast.info(`File "${file.name}" is not allowed.`);
            return;
        }

        // Get file extension
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Validate file extension
        if (!allowedExtensions.includes(fileExtension)) {
            toast.info(`File "${file.name}" has an invalid extension.`);
            return;
        }

        if (file) {
            setSelectedFile(file);
        }
    };

    const handleFileSubmit = async () => {
        // if (!selectedFile) return;
        if (selectedFile) {
            const formData = new FormData();
            formData.append(selectedFile.name, selectedFile);
            formData.append('vendor_code', vendorCode);
            try {
                setPostLoading(true)
                const action = dispatch(assetDeclarationFileUpload(formData));
                const res = await action.unwrap();
                console.log("res from pv log:", res);
                if (res.StatusCode === 200) {
                    setPostLoading(false)
                    toast.success("File Upload Done");
                    setTimeout(() => {
                        navigate("/asset-declaration-history");
                    }, 2000);
                } else {
                    toast.error("Something went wrong!")
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        } else {
            toast.warning(`No file selected`);
        }
    };


    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        PLI Asset Declaration Upload
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="PLI Asset Declaration Upload" />
                </Box>
                <Box mb={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="h6" gutterBottom>
                                Upload Declaration
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <input
                                type="file"
                                hidden
                                id="UploadDec"
                                accept=".pdf,.doc,.docx"
                                // accept=".doc,.docx"
                                onChange={handleFileUpload}
                            />
                            <label htmlFor="UploadDec">
                                <Button variant="contained" component="span" color="primary" disabled={Role === "admin" ? true : false}>
                                    Select File
                                </Button>
                            </label>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{ marginTop: 8 }}
                            >
                                Note - Only word file can be attached
                            </Typography>
                            {selectedFile && (
                                <>
                                    <Box mt={2}>
                                        <Typography variant="body1" gutterBottom>
                                            Selected File: {selectedFile.name}
                                        </Typography>
                                    </Box>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleFileSubmit}
                                        style={{ marginTop: '10px' }}
                                        startIcon={postLoading && <CircularProgress size={20} />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? 'Uploading...' : 'Upload File'}
                                    </Button>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                {/* Add Section for Downloading Templates */}
                {/* <Box mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Download Templates
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Button
                                variant="contained"
                                color="secondary"
                                // href={require('../../Assets/template1.docx').default}
                                href={template1}
                                download
                            >
                                Template 1
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button
                                variant="contained"
                                color="secondary"
                                href={template2}
                                download
                            >
                                Template 2
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button
                                variant="contained"
                                color="secondary"
                                href={template3}
                                download
                            >
                                Template 3
                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}
                <Box mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Download Templates
                    </Typography>
                    <Grid container spacing={2}>
                        {/* Template 1 */}
                        <Grid item xs={12} sm={4}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <InsertDriveFileIcon style={{ fontSize: 80, color: '#3f51b5' }} />
                                <Typography variant="body1" gutterBottom>
                                    TML PV Pune
                                </Typography>
                                <Button
                                    variant="contained"
                                    style={{ backgroundColor: 'green', color: 'white', marginTop: '10px' }}
                                    href={template1}
                                    download="TML PV Pune.docx"
                                >
                                    Download
                                </Button>
                            </Box>
                        </Grid>

                        {/* Template 2 */}
                        <Grid item xs={12} sm={4}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <InsertDriveFileIcon style={{ fontSize: 80, color: '#3f51b5' }} />
                                <Typography variant="body1" gutterBottom>
                                    TML PV Sanand
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    href={template2}
                                    download="TML PV Sanand.docx"
                                    style={{ backgroundColor: 'green', color: 'white', marginTop: '10px' }}
                                >
                                    Download
                                </Button>
                            </Box>
                        </Grid>

                        {/* Template 3 */}
                        <Grid item xs={12} sm={4}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <InsertDriveFileIcon style={{ fontSize: 80, color: '#3f51b5' }} />
                                <Typography variant="body1" gutterBottom>
                                    TML EV Sanand
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    href={template3}
                                    download="TML EV Sanand.docx"
                                    style={{ backgroundColor: 'green', color: 'white', marginTop: '10px' }}
                                >
                                    Download
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default UploadAssetDeclaration;
